/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Guess_Capital_PromptInputs */

const bn_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রাজধানী শহর অনুমান.`)
};

const de_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erraten Sie die Hauptstadt.`)
};

const el_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαντέψτε την πρωτεύουσα.`)
};

const en_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guess the capital city.`)
};

const es_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adivina la ciudad capital.`)
};

const fr_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devinez la capitale.`)
};

const hi_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`राजधानी शहर का अनुमान लगाएं.`)
};

const hu_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találd meg a fővárost.`)
};

const id_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebak ibu kotanya.`)
};

const it_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indovina la capitale.`)
};

const ja_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首都を推測します。`)
};

const ko_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수도를 추측해 보세요.`)
};

const nl_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raad de hoofdstad.`)
};

const pl_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgadnij stolicę.`)
};

const pt_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adivinhe a capital.`)
};

const ru_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Угадайте столицу.`)
};

const sv_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gissa huvudstaden.`)
};

const tr_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başkenti tahmin et.`)
};

const uk_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вгадай столицю.`)
};

const vi_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đoán thủ đô.`)
};

const zh_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜猜首都。`)
};

const zh_hant_game_guess_capital_prompt = /** @type {(inputs: Game_Guess_Capital_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜猜首都。`)
};

/**
* | output |
* | --- |
* | "Guess the capital city." |
*
* @param {Game_Guess_Capital_PromptInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_guess_capital_prompt = /** @type {((inputs?: Game_Guess_Capital_PromptInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Guess_Capital_PromptInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_guess_capital_prompt(inputs)
	if (locale === "de") return de_game_guess_capital_prompt(inputs)
	if (locale === "el") return el_game_guess_capital_prompt(inputs)
	if (locale === "en") return en_game_guess_capital_prompt(inputs)
	if (locale === "es") return es_game_guess_capital_prompt(inputs)
	if (locale === "fr") return fr_game_guess_capital_prompt(inputs)
	if (locale === "hi") return hi_game_guess_capital_prompt(inputs)
	if (locale === "hu") return hu_game_guess_capital_prompt(inputs)
	if (locale === "id") return id_game_guess_capital_prompt(inputs)
	if (locale === "it") return it_game_guess_capital_prompt(inputs)
	if (locale === "ja") return ja_game_guess_capital_prompt(inputs)
	if (locale === "ko") return ko_game_guess_capital_prompt(inputs)
	if (locale === "nl") return nl_game_guess_capital_prompt(inputs)
	if (locale === "pl") return pl_game_guess_capital_prompt(inputs)
	if (locale === "pt") return pt_game_guess_capital_prompt(inputs)
	if (locale === "ru") return ru_game_guess_capital_prompt(inputs)
	if (locale === "sv") return sv_game_guess_capital_prompt(inputs)
	if (locale === "tr") return tr_game_guess_capital_prompt(inputs)
	if (locale === "uk") return uk_game_guess_capital_prompt(inputs)
	if (locale === "vi") return vi_game_guess_capital_prompt(inputs)
	if (locale === "zh") return zh_game_guess_capital_prompt(inputs)
	return zh_hant_game_guess_capital_prompt(inputs)
});